<template>
  <div id="comment-submit-form">
    <div
      v-if="listOfUsers.length || isReply"
      :class="['d-flex', 'px-3', 'py-2', 'send-notify-for-user']"
    >
      <!-- Кнопка "Отправить визитку" -->
      <div
        v-if="!isReply && (formSelected.value === 1 || formSelected.value === 2)"
        class="mr-2 d-flex align-items-center"
      >
        <b-button
          variant="outline-secondary"
          size="sm"
          class="visit-card-button"
          @click="insertVisitCard"
          title="Отправить визитку"
        >
          <b-icon icon="person-lines-fill" aria-hidden="true"></b-icon>
        </b-button>
      </div>

      <div
        v-if="!isReply"
        class="mr-3 pt-1 pb-1"
        @mouseenter="openForms()"
        @mouseleave="closeForms($event)"
      >
        <div 
          class="form-selector"
        >
          {{ formSelected.text }}
        </div>
        <div
          ref="formGroupWrapper"
          class="form-group-wrapper"
          :class="!isAgent ? '' : 'form-group-wrapper-agent'"
        >
          <span 
            v-for="form in filteredFormGroup"
            :key="form.value"
            class="form-group-form"
            :class="formSelected.value === form.value ? 'form-group-form-active' : ''"
            :title="form.description"
            @click="selectForm(form)"
          >
            {{ form.text }}
          </span>
        </div>
      </div>


      <div v-if="isReply" class="reply-text">Ответ на сообщение <span style="font-weight: bold;">{{ clearTagComment(text) }}</span></div>

      <div 
        v-if="listOfUsers.length && !isReply && !oldValue" 
        class="d-flex align-items-center"
        style="margin-top: 3px;"
      >
        <b-form-checkbox
          v-if="formSelected.value === 1"
          id="checkbox-send-notification"
          v-model="sendNotification"
          name="checkbox-send-notification"
          :value="true"
          :unchecked-value="false"
          class="d-inline font-size-12"
          style="line-height: 23px;"
        >
          Отправить уведомление
        </b-form-checkbox>

        <div
          v-if="formSelected.value === 4"
          class="mr-2"
        >на</div>

        <div
          v-if="formSelected.value === 4" 
          class="task-date-wrapper d-flex align-items-center mr-2"
        >
          <div class="mr-2">{{ transformDate(taskData.realization_at) }}</div>

          <input
            type="datetime-local"
            class="task-date-button"
            v-model="taskData.realization_at"
          >
        </div>

        <div
          v-if="formSelected.value === 4"
          class="mr-2"
        >для</div>

        <div
          v-if="formSelected.value === 1 || formSelected.value === 4"
          class="d-inline pl-1"
          style="padding-top: 1px;"
        >
          <b-dropdown
            size="sm"
            variant="link"
            no-caret
            class="send-notify-drop-btn"
          >
            <template #button-content>
              {{ outputSelectedUserLine() }}
            </template>
            <b-dropdown-item
              v-for="(item, index) in sendToUsersList"
              :key="index"
              @click="changeSelectedUserList(item.value, index)"
            >
              <span
                v-if="item.selected"
                class="font-size-12"
              >&check;</span> {{ item.name }}
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <div 
          v-if="formSelected.value === 3"
          class="d-flex align-items-center"
        >
          <p class="mb-0 mr-1">Как прошел звонок:</p>
          <b-dropdown
            size="sm"
            variant="link"
            no-caret
            class="send-notify-drop-btn"
          >
            <template #button-content>
              {{ callSelected.name }}
            </template>
            <b-dropdown-item
              v-for="callStatus in callStatuses"
              :key="callStatus.id"
              @click="changeCallStatus(callStatus.id)"
            >
              <span
                v-if="callSelected.id === callStatus.id"
                class="font-size-12"
              >&check;</span> {{ callStatus.name }}
            </b-dropdown-item>
          </b-dropdown>
          <!-- <p class="mb-0">Комментарий к звонку:</p> -->
        </div>
      </div>
    </div>

    <div
      v-if="formSelected.value === 4"
      class="d-flex px-3 py-2 send-notify-for-user send-notify-for-user-with-border"
    >
      <div 
        class="mr-3 d-flex align-items-center"
        style="width: 40%;"
      >
        <label 
          class="mb-0 mr-1"
          for="type-reference-task"
          style="width: 55px;"
        >Тип</label>
        <b-form-select v-model="taskData.reference_type_id" :options="options"></b-form-select>
      </div>

      <div 
        class="mr-0 d-flex align-items-center"
        style="width: 60%;"
      >
        <label 
          class="mb-0 mr-1"
          for="title-task"
          style="width: 100px;"
        >Заголовок</label>
        <input
          type="text"
          class="form-control bg-white"
          style="height: 37px;"
          id="title-task"
          placeholder="Введите название задачи..."
          v-model="taskData.title"
        >
      </div>
    </div>

    <form
      v-if="formSelected.value === 1 || formSelected.value === 2"
      class="textarea"
      @submit.prevent="submit"
      @keydown.ctrl.enter.exact.prevent="submit"
      @mousedown="resizeTextArea($event, 'ql-editor', 300)"
    >
      <VueEditor
        class="comment-editor"
        ref="editor"
        v-model="value"
        :editorToolbar="customToolbar"
      />

      <div class="textarea__footer">
        <b-button
          title="Прикрепить файлы"
          v-if="needFileUploadButton && !oldValue"
          @click="checkedLoadDocument=!checkedLoadDocument"
          :variant="checkedLoadDocument ? 'success' : 'secondary'"
          class="ml-1 mr-3"
          size="sm"
        >
          <b-icon icon="cloud-upload" aria-hidden="true"></b-icon>
        </b-button>

        <div class="text-muted small"><b>CTRL + ENTER</b> &mdash; Отправить</div>

        <b-overlay
          :show="loading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="ml-auto"
        >
          <button 
            class="comment__button cursor-pointer btn-sm" 
            :class="{ disabled: disabledButton }"
          >
            {{ isReply ? 'Ответить' : 'Отправить' }}
          </button>
          <button 
            v-if="isReply || oldValue" 
            class="comment__button cursor-pointer btn-sm" 
            @click="cancelReplyOrEdit"
          >Отмена</button>
        </b-overlay>
      </div>

      <tsoft-upload-area
        v-if="checkedLoadDocument && needFileUploadButton"
        @changed="addFiles"
      />
    </form>

    <form
      v-if="formSelected.value === 3 || formSelected.value === 4"
      @submit.prevent="submitTaskOrCall"
      @keydown.ctrl.enter.exact.prevent="submitTaskOrCall"
      class="textarea"
    >
      <b-form-textarea
        v-if="formSelected.value === 3"
        class="comment-editor-middle"
        v-model="value"
        placeholder="Комментарий к звонку...."
        rows="4"
      ></b-form-textarea>

      <div
        v-if="formSelected.value === 4"
        class="comment-editor-low"
      >
        <textarea
          cols="30"
          rows="3"
          class="form-control bg-white"
          placeholder="Введите описание задачи..."
          v-model="taskData.description"
        ></textarea>
      </div>

      <div class="textarea__footer">
        <b-button
          title="Прикрепить файлы"
          v-if="needFileUploadButton && !oldValue"
          @click="checkedLoadDocument=!checkedLoadDocument"
          :variant="checkedLoadDocument ? 'success' : 'secondary'"
          class="ml-1 mr-3"
          size="sm"
        >
          <b-icon icon="cloud-upload" aria-hidden="true"></b-icon>
        </b-button>

        <div class="text-muted"><b>CTRL + ENTER</b> &mdash; Отправить</div>

        <b-overlay
          v-if="formSelected.value === 4"
          :show="loading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="ml-auto"
        >
          <button 
            class="comment__button cursor-pointer btn-sm"
          >
            Создать
          </button>
        </b-overlay>

        <b-overlay
          v-else-if="formSelected.value === 3"
          :show="loading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="ml-auto"
        >
          <button
            class="comment__button cursor-pointer btn-sm"
          >
            Отправить
          </button>
        </b-overlay>
      </div>

      <tsoft-upload-area
        v-if="checkedLoadDocument && needFileUploadButton"
        @changed="addFiles"
      />
    </form>
  </div>
</template>

<!-- НЕТ АДРЕСАТА В КОММЕНТАРИИ -->
<script>
  import { VueEditor } from "vue2-editor";
  import { API_TASKS, API_USER_CALL } from '@/constants';
  import { defaultDataItems } from '@/mixins';
  import { mapGetters } from "vuex";

  export default {
    components: {
      VueEditor,
    },

    props: {
      loading: { type: Boolean, default: false },
      idComment: { type: Number | String, default: '' },
      noFocus: { type: Boolean, default: false },
      isReply: {  type: Boolean, default: false },
      text: { type: String, default: '' },
      oldValue: { type: String, default: '' },
      needFileUploadButton: { type: Boolean, default: false },
      listOfUsers: {
        type: Array,        // [{name: 'Mikl', value: 1, selected: false}]
        default: () => [],
      },
      isNeedToRefresh: { type: Boolean, default: false },
      elementIds: { type: Array, default: () => [] },
      orderId: { type: String|Number, default: ''},
      companyId: { type: String|Number, default: ''}, // for task
      company_id: { type: String|Number, default: ''}, // for call comment
      financeId: { type: String|Number, default: ''},
      elementDBField: { type: String|Number, default: ''},
      outbound_number: { type: String, default: '' },
      target_id: { type: Number, default: null },
      target_type: { type: String, default: null },
    },

    mixins: [defaultDataItems],

    data() {
      return {
        value: "",
        customToolbar: [
          // [{ header: [false, 1, 2, 3, 4, 5, 6] }],
          ["bold", "italic", "underline", "strike"],
          ["blockquote"],
          [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
          [{ color: [] }, { background: [] }],
          // ["clean"]
        ],
        checkedLoadDocument: false,
        sendNotification: true,
        sendToUsersList: [],
        selectedUsersToSend: [],
        formSelected: {value: 1, text: 'Сообщение'},
        formGroup: [
          {
            value: 1, text: 'Сообщение', description: 'Сообщение с получателями или без' 
          },
          {
            value: 2, text: 'Примечание', description: 'Сообщение без конкретных получателей'
          },
          {
            value: 3, text: 'Звонок', description: 'Зафиксировать звонок, выполненный вне системы'
          },
          {
            value: 4, text: 'Задача', description: 'Установить задачу по текущей поставке'
          },
        ],
        taskData: {
          order_id: '',
          company_id: '',
          finance_id: '',
          order_service_id: '',
          title: '',
          description: '',
          realization_at: this.$moment().format('YYYY-MM-DDTHH:mm'),
          reference_type_id: '406',
          realizators: [],
        },
        options: [
          { value: '405', text: 'Связаться', title: 'Необходимо связаться с клиентом' },
          { value: '404', text: 'Встреча', title: 'Встреча с клиентом' },
          { value: '547', text: 'Узнать ответ на КП', title: 'Узнать ответ на КП' },
          { value: '548', text: 'Договор', title: 'Получить обратную связь по договору' },
          { value: '406', text: 'Другое' }
        ],
        callSelected: {status: 'Accepted', name: 'Дозвонился', id: 1},
        callStatuses: [
          {status: 'Accepted', name: 'Дозвонился', id: 1},
          {status: 'Busy', name: 'Занято', id: 2},
          {status: 'Not accepted', name: 'Не взял трубку', id: 3},
          {status: 'Error', name: 'Ошибка соединения', id: 4},
        ],
        yeastar_phone_number: '9999999999', // custom, заглушка
      };
    },

    watch: {
      "listOfUsers": {
        handler(users) {
          if (users.length > 0) {
            this.sendToUsersList = [];

            if (users.length > 1) {
              this.sendToUsersList.push({
                name: 'Всем',
                value: 'all',
                selected: false
              });
            }

            users.forEach((user) => {
              this.sendToUsersList.push({
                name: user.name,
                value: user.value,
                selected: false
              });
            });

            this.setDefaultSelectedElement();
          } else {
            this.sendToUsersList = [];
          }
        },
        immediate: true,
        deep: true
      },
      formSelected() {
        if (this.formSelected.value === 1) {
          this.sendToUsersList.unshift({
            name: 'Всем',
            value: 'all',
            selected: true
          });
          this.setDefaultSelectedElement();
          
        } else {
          this.sendToUsersList = this.sendToUsersList.filter(user => user.value !== 'all')
          this.sendToUsersList[0].selected = true;
        }
        if (this.formSelected.value === 1 || this.formSelected.value === 2) {
          this.$nextTick(() => this.creatLine());
        }
      },
      isReply: {
        handler() {
          if (this.isReply) {
            this.onReply();
          }
        }
      },
      oldValue: {
        handler() {
          if (this.oldValue) {
            this.onEdit();
          }
        }
      },
      isNeedToRefresh: {
        handler() {
          if (this.isNeedToRefresh) {
            this.resetValues();
          }
        }
      },
      'taskData.reference_type_id': function(reference_type_id) {
        this.taskData.title = '';
        if (!this.taskData.title) {
          let findElem = this.options.find(element => {
            if (element.value == reference_type_id) {
              return element
            }
          })

          if (findElem !== 'undefined') {
            this.taskData.title = findElem.title;
          }
        }
      },
      orderId: {
        handler(value) {
          this.taskData.order_id = value
        },
        immediate: true
      },
      companyId: {
        handler(value) {
          this.taskData.company_id = value
        },
        immediate: true
      },
      financeId: {
        handler(value) {
          this.taskData.finance_id = value
        },
        immediate: true
      },
    },
    computed: {
      ...mapGetters("auth", ["currentUser"]),

      disabledButton() {
        return this.value.length === 0;
      },

      isAgent() {
        return this.currentUser && this.currentUser.role.includes('agent');
      },

      filteredFormGroup() {
        // Если пользователь с ролью agent, показываем только "Сообщение" и "Примечание"
        if (this.isAgent) {
          return this.formGroup.filter(form => form.value === 1 || form.value === 2);
        }
        // Для остальных ролей показываем все опции
        return this.formGroup;
      },
    },
    created() {
      if (this.noFocus) return false;
      this.$nextTick(() => {
        if (this.$refs && this.$refs.editor) {
          this.$refs.editor.quill.focus();
        }
      });
    },
    mounted() {
      !!this.oldValue ? (this.value = this.oldValue) : "";
      this.creatLine();
    },
    methods: {
      submit() {
        if (this.value.length === 0) return false;
        this.prepareSelectedUsersForNotification();

        // Если примечание - почистим список доставки
        if (this.formSelected.value == 2) {
          this.selectedUsersToSend = [];
          this.$emit("setUsersForNotifications", this.selectedUsersToSend);
        } 

        if (this.isReply) {
          this.$emit('setReplyComment', {
            idComment: this.idComment,
            comment: this.value,
          });
        } else if (this.oldValue) {
          this.$emit('setEditComment', {
            idComment: this.idComment,
            comment: this.value,
          });
        } else {
          this.$emit('submit', this.value);
        }

        this.resetValues();
      },
      submitTaskOrCall() {
        if (this.formSelected.value === 4) {
          this.createTask();
        } else if (this.formSelected.value === 3) {
          this.submitStatusCall();
        }
      },
      addFiles(files) {
        this.$emit("addFiles", files);
      },
      changeSelectedUserList(value, index) {
        if (this.formSelected.value !== 4) {
          if (index === 0) {
            this.setDefaultSelectedElement();
            return true;
          }

          this.sendToUsersList[0].selected = false;
          this.sendToUsersList[index].selected = !this.sendToUsersList[index].selected;

          if (this.sendToUsersList.find(user => user.selected) === undefined) {
            this.setDefaultSelectedElement();
          }
        } else {
          this.sendToUsersList[index].selected = !this.sendToUsersList[index].selected;
          if (this.sendToUsersList.find(user => user.selected) === undefined) {
            this.sendToUsersList[0].selected = true;
          }
        }

        return true;
      },
      changeCallStatus(index) {
        this.callStatuses.forEach(status => {
          if (status.id === index) {
            this.callSelected = status;
          }
        });
      },
      outputSelectedUserLine() {
        let filteredList = this.sendToUsersList.filter(user => user.selected);

        return filteredList.map((user) => {
          return user.name
        }).join(', ');
      },
      outputSelectedUserPhone() {
        let filteredList = this.sendToUsersList.filter(user => user.selected);

        return filteredList.map((user) => {
          return user
        }).join(', ');
      },
      setDefaultSelectedElement() {
        this.sendToUsersList.forEach(user => user.selected = false);
        this.sendToUsersList[0].selected = true;
      },
      prepareSelectedUsersForNotification() {
        if (this.sendNotification) {
          if (this.sendToUsersList && this.sendToUsersList.length > 0) {
            // Если выбрано отправить ВСЕМ
            if (this.sendToUsersList[0].selected && this.sendToUsersList[0].value == 'all') {
              this.sendToUsersList.forEach((user, index) => {
                if (index !== 0 && user.value != 'all') {
                  this.selectedUsersToSend.push(user.value);
                }
              })
            } else {
              this.sendToUsersList.forEach((user) => {
                if (user.selected && user.value != 'all') {
                    this.selectedUsersToSend.push(user.value);
                }
              })
            }
          }

          this.$emit("setUsersForNotifications", this.selectedUsersToSend);
        }
      },
      resetValues() {
        this.sendNotification = true;
        this.checkedLoadDocument = false;
        this.$refs.editor.quill.setText('');
        this.value = '';
        this.selectedUsersToSend = [];
        this.$emit('refreshed');
        this.$emit("addFiles", []);
      },
      onReply() {
        this.resetValues();
        this.$refs.editor.quill.focus();
      },
      onEdit() {
        this.resetValues();
        this.value = this.oldValue;
      },
      cancelReplyOrEdit() {
        this.resetValues();
        this.$emit('cancelReplyOrEdit');
      },
      clearTagComment(comment) {
        return comment.replace(/<\/?[^>]+(>|$)/gi, " ");
      },
      openForms() {
        this.$refs.formGroupWrapper.classList.add('form-group-wrapper-active');
      },
      closeForms(event) {
        if (!event.target.classList.contains('.form-group-wrapper') || !event.target.classList.contains('.form-selector')) {
          this.$refs.formGroupWrapper.classList.remove('form-group-wrapper-active');
        }
      },
      selectForm(form) {
        this.formSelected = form;
        if (this.formSelected.value == 1) {
          this.sendNotification = true;
        } else {
          this.sendNotification = false;
        }
        this.$refs.formGroupWrapper.classList.remove('form-group-wrapper-active');
      },
      transformDate(date) {
        if (date) {
          return new Date(date).toLocaleString('ru-RU', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' });
        } else {
          return new Date().toLocaleString('ru-RU', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' });
        }
      },
      createTask() {
        let usersArray = [];

        for (let realizatorItem in this.sendToUsersList) {
          if (this.sendToUsersList[realizatorItem].selected && (this.sendToUsersList[realizatorItem].value !== 'all')) {
            let selectedUsers = {
              realizator_user_id: this.sendToUsersList[realizatorItem].value,
            };
            usersArray.push(selectedUsers);
          }
        }

        this.taskData.realizators = usersArray;

        // Признак массовой задачи для бэкенда
        if (this.elementIds.length > 0) {
          this.taskData.elementIds = this.elementIds;
          this.taskData.elementDBField = this.elementDBField;
        }

        api.call('post', API_TASKS, this.taskData)
          .then(({data}) => {
            this.$emit('setNewCreatedTask', data);

            usersArray = [];

            this.makeToast('success', 'Задача создана');
            this.setToGetAllHistoryTasks();
            this.refreshData();
          })
      },
      setToGetAllHistoryTasks() {
        this.$emit('setToGetAllHistoryTasks');
      },
      refreshData() {
        this.taskData = {
          order_id: '',
          company_id: '',
          finance_id: '',
          order_service_id: '',
          title: '',
          description: '',
          realization_at: this.$moment().format('YYYY-MM-DDTHH:mm'),
          reference_type_id: '406',
          realizators: [],
        };
        this.formSelected = {value: 1, text: 'Сообщение'};
      },
      async submitStatusCall() {
        const params = {
          status: this.callSelected.status,
          comment: this.value,
          yeastar_phone_number: this.yeastar_phone_number,
          outbound_id: new Date().getTime().toString(),
          company_id: this.company_id,
          outbound_number: this.outbound_number,
          target_id: this.target_id,
          target_type: this.target_type,
          user_id: this.currentUser.id,
        };

        await axios.post(API_USER_CALL, params);
        this.value = "";
        this.$emit("updateOrderHistory");
      },
      creatLine() {
        if (document.querySelector('.ql-toolbar-line')) return;

        const top = document.querySelector('.ql-toolbar');
        top.insertAdjacentHTML('afterend', '<div class="ql-toolbar-line"></div>');
      },
      resizeTextArea(e, elemName, maxHeight) {
        if (e.target.className === 'ql-toolbar-line') {
          const el = document.querySelector(`.${elemName}`);
          this.setListener(e, el, maxHeight);
        }
      },
      setListener(e, el, maxHeight) {
        const DEFAULT_SIZE = maxHeight;
        const MINIMUM_SIZE = 99;

        function resize(e) {
          let m_pos = window.innerHeight - e.y - 48; // 48 это высота блока перед нашим элементом

          if (m_pos > MINIMUM_SIZE) {
            el.style.maxHeight = `${m_pos}px`;
            el.style.height = `${m_pos}px`;
          }

          if (m_pos > DEFAULT_SIZE) {
            el.style.maxHeight = `${DEFAULT_SIZE}px`;
            el.style.height = `${DEFAULT_SIZE}px`;
          }

          if (m_pos <= MINIMUM_SIZE) {
            el.style.maxHeight = `${MINIMUM_SIZE}px`;
            el.style.height = `${MINIMUM_SIZE}px`;
          }
        }

        const mouseUp = () => {
          el.classList.remove('moved');
          window.removeEventListener('mousemove', resize);
          window.removeEventListener('mouseup', mouseUp);
        }

        if (e.target.className === 'ql-toolbar-line') {
          el.classList.add('moved');
          window.addEventListener('mousemove', resize);
        }

        window.addEventListener('mouseup', mouseUp);
      },
      insertVisitCard() {
        if (!this.currentUser) return;
        
        // Создаем HTML-шаблон визитки
        const visitCardHtml = `
          <div class="visit-card" style="
            border: 1px solid #ddd;
            border-radius: 8px;
            padding: 12px;
            margin: 8px 0;
            background-color: #f8f9fa;
            max-width: 300px;
          ">
            <div style="font-style: italic; margin-bottom: 6px; color: #666; font-size: 0.9em;">
              По всем вопросам можете обращаться ко мне.
            </div>
            <div style="font-weight: bold; margin-bottom: 8px; color: #333;">
              ${this.currentUser.name || ''}
            </div>
            ${this.currentUser.phone ? `
              <div style="margin-bottom: 4px; color: #666;">
                📞 ${this.currentUser.phone}
              </div>
            ` : ''}
            ${this.currentUser.email ? `
              <div style="margin-bottom: 4px; color: #666;">
                ✉️ ${this.currentUser.email}
              </div>
            ` : ''}
            ${this.currentUser.position ? `
              <div style="margin-bottom: 4px; color: #666;">
                💼 ${this.currentUser.position}
              </div>
            ` : ''}
          </div>
        `;
        
        // Вставляем визитку в редактор
        if (this.$refs.editor && this.$refs.editor.quill) {
          const quill = this.$refs.editor.quill;
          const range = quill.getSelection();
          
          if (range) {
            // Вставляем в текущую позицию курсора
            quill.clipboard.dangerouslyPasteHTML(range.index, visitCardHtml);
            // Перемещаем курсор после вставленной визитки
            quill.setSelection(range.index + visitCardHtml.length);
          } else {
            // Если курсор не установлен, вставляем в конец
            quill.clipboard.dangerouslyPasteHTML(quill.getLength(), visitCardHtml);
            quill.setSelection(quill.getLength());
          }
          
          // Фокусируемся на редакторе
          quill.focus();
        }
      },
    },
  };
</script>

<style lang="scss">
  .comment-editor {
    .ql-editor {
      min-height: 99px;
      max-height: 99px;
      height: 99px;
    }
    .ql-toolbar {
      height: 46px;
      overflow-x: inherit;
    }
  }
  .ql-toolbar-line {
    height: 3px;
    background-color: #ccc;
    cursor: n-resize;
    transition: 0.3s;

    &:hover {
      background-color: var(--green);
      box-shadow: 2px 0px 6px 1px var(--green);
    }
  }
  .ql-formats {
    margin-bottom: 0 !important;
  }
  .comment-editor-middle {
    min-height: 146px;
    height: 146px;
  }
  .comment-editor-low {
    textarea {
      min-height: 100px;
      height: 100px;
    }
  }
  .textarea {
    background: #fff;
    &__field {
      &:focus {
        border-color: #ea7b27;
      }
    }
    &__footer {
      display: flex;
      align-items: center;
      border: 1px solid #dadada;
      border-top: none;
      padding: 3px 10px;
      background: #e9e9e9;
    }
  }
  .send-notify-for-user {
    position: relative;
    align-items: center;
    height: 46px;
    background: #E9E9E9;
    align-items: center;
    justify-content: flex-start;
  }
  .send-notify-for-user-with-border {
    border-bottom: 1px solid #cfcfcf;
  }
  .send-notify-drop-btn {
    text-align: left;
    padding: 0;
    margin: 0;
  }
  .send-notify-drop-btn button {
    white-space: normal;
    text-align: left;
  }
  .form-selector {
    position: relative;
    width: auto;
    color: #3490dc;
    font-size: 0.7875rem;
    line-height: 1.5;
    text-decoration: underline;
    cursor: pointer;
  }
  .form-group-wrapper {
    position: absolute;
    top: -122px;
    left: 10px;
    display: flex;
    flex-direction: column;
    min-width: 140px;
    width: 140px;
    max-height: 0;
    transform: translateY(130px);
    opacity: 0;
    transition: 500ms all ease;
    background: #fff;
    box-shadow: 0 2px 5px rgb(0 0 0/15%);
    border-radius: 3px;
    overflow: hidden;

    &-active {
      transform: translateY(0);
      opacity: 1;
      max-height: 135px;
      transition: 500ms all ease;
    }
  }
  .form-group-wrapper-agent {
    top: -61px;
  }
  
  .form-group-form {
    position: relative;
    padding: 5px 5px 5px 10px;
    width: 100%;
    cursor: pointer;

    &:hover {
      background-color: #E9E9E9;
    }

    &-active::after {
      content: '';
      background-image: url('/img/checked.svg');
      position: absolute;
      width: 9px;
      height: 7px;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .task-date-wrapper {
    position: relative;

    &:hover {
      border-bottom: 1px dashed #3490dc;
    }    
  }
  .task-date-button {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    opacity: 0;

    &::-webkit-datetime-edit {
      display: none;
    }

    &::-webkit-calendar-picker-indicator {
      width: 100%;
      cursor: pointer;
    }
  }
  
  .visit-card-button {
    height: 23px !important;
    width: 23px !important;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.2s ease;
    
    &:hover {
      background-color: #e9ecef;
      border-color: #adb5bd;
    }
    
    .b-icon {
      font-size: 13px;
    }
  }
  
  .visit-card {
    display: inline-block;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 12px;
    margin: 8px 0;
    background-color: #f8f9fa;
    max-width: 300px;
    font-family: inherit;
    
    div {
      margin-bottom: 4px;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>
